export const profDesignationDesc = {
  CLU: "Chartered Life Underwriter (CLU)",
  CHFC: "Chartered Financial Consultant (CHFC)",
  MSFS: "Master of Science in Financial Services (MSFS)",
  CFP: "Certified Financial Planner (CFP)",
  CIC: "Certified Insurance Counselor (CIC)",
  LUTCF: "Life Underwriter Training Council Fellow (LUTCF)",
  FLMI: "Fellow, Life Management Institute (FLMI)",
  RHU: "Registered Health Underwriter (RHU)",
  MSM: "Master of Science in Management (MSM)",
  RIA: "Registered Investment Advisor (RIA)",
  JD: "Juris Doctor (JD)",
  PFS: "Personal Financial Specialist (PFS)",
  CFA: "Chartered Financial Analyst (CFA)",
  Other: "Other",
};

export const profDesignationID = {
  CLU: 1,
  CHFC: 2,
  MSFS: 3,
  CFP: 4,
  CIC: 5,
  LUTCF: 6,
  FLMI: 7,
  RHU: 8,
  MSM: 9,
  RIA: 10,
  JD: 11,
  PFS: 12,
  CFA: 13,
  Other: 14,
};


export const PD_ACTIONS = {
  SET_LOADING_DESIGNATIONS: "SET_LOADING_DESIGNATIONS",
  SET_AVAILABLE_DESIGNATIONS: "SET_AVAILABLE_DESIGNATIONS",
  SET_HAS_DESIGNATIONS: "SET_HAS_DESIGNATIONS",
  SET_HAS_DESIGNATIONS_ERROR: "SET_HAS_DESIGNATIONS_ERROR",
  ADD_DESIGNATION_ROW: "ADD_DESIGNATION_ROW",
  REMOVE_DESIGNATION_ROW: "REMOVE_DESIGNATION_ROW",
  UPDATE_DESIGNATION_ROW: "UPDATE_DESIGNATION_ROW",
  SET_ROW_ERROR: "SET_ROW_ERROR",
  CLEAR_ROW_ERROR: "CLEAR_ROW_ERROR",
  LOAD_EXISTING_DATA: "LOAD_EXISTING_DATA",
  SET_DATA_FETCHED: "SET_DATA_FETCHED",
  SET_SHOW_BACK_MODAL: "SET_SHOW_BACK_MODAL",
  SET_FORM_CHANGED: "SET_FORM_CHANGED",
  RESET_FORM: "RESET_FORM",
  MARK_ROW_SAVED: "MARK_ROW_SAVED",
  CLEAR_DELETED_ROWS: "CLEAR_DELETED_ROWS",
  RESET_CHANGE_TRACKING: "RESET_CHANGE_TRACKING",
  MAX_DISPLAY_LENGTH: 36,
  MAX_DROPDOWN_DISPLAY_LENGTH: 44,
};

/**
 * Row status constants for tracking changes
 */
export const ROW_STATUS = {
  UNCHANGED: "unchanged",
  NEW: "new",
  MODIFIED: "modified",
};

/**
 * Autocomplete placeholder and validation messages
 */
export const PD_AUTOCOMPLETE = {
  PLACEHOLDER: "Search designations",
  DEFAULT_LABEL: "Professional Designation",
  VALIDATION_MESSAGES: {
    INVALID_DESIGNATION: "Please enter a valid Designation",
    ALREADY_SELECTED: "This designation has already been selected",
  },
  ARIA_LABELS: {
    CLEAR_SELECTION: "Clear selection",
    CLOSE_DROPDOWN: "Close dropdown",
    OPEN_DROPDOWN: "Open dropdown",
  },
  KEYBOARD_KEYS: {
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    ENTER: "Enter",
    TAB: "Tab",
    ESCAPE: "Escape",
    HOME: "Home",
    END: "End",
  },
};

